import React from 'react';
import { observable, computed, autorun, toJS } from 'mobx';
import { getIn } from '../utils';
import * as constants from '../model/const';
import confirmationDialog from '../model/ConfirmationDialog';


import translateBase from '../translate';
let translate = translateBase.bindPage('userBookingDetail');

class MainObjectOffer {
  constructor(content) {
    this._content = content;
  }

  @computed get id() {
    return getIn(this._content, ['Id']);
  }

  @computed get name() {
    return getIn(this._content, ['RentalObjectName']);
  }

  @computed get seasonName() {
    return getIn(this._content, ['SeasonName']);
  }

  @computed get offerName() {
    return getIn(this._content, ['Name']);
  }

  @computed get offerQuantity() {
    return getIn(this._content, ['OfferQuantity']);
  }

  @computed get rentalObjectQuantity() {
    return getIn(this._content, ['RentalObjectQuantity']);
  }

  @computed get price() {
    return getIn(this._content, ['TotalPrice']);
  }

  @computed get prolongationOfferQuantity() {
    return getIn(this._content, ['ProlongationOfferQuantity']);
  }

  @computed get prolongationName() {
    return getIn(this._content, ['ProlongationName']);
  }
}

class AccessoryOffer {
  constructor(content) {
    this._content = content;
  }

  @computed get id() {
    return getIn(this._content, ['Id']);
  }

  @computed get name() {
    return getIn(this._content, ['RentalObjectName']);
  }

  @computed get offerQuantity() {
    return getIn(this._content, ['OfferQuantity']);
  }

  @computed get rentalObjectQuantity() {
    return getIn(this._content, ['RentalObjectQuantity']);
  }

  @computed get seasonName() {
    return getIn(this._content, ['SeasonName']);
  }

  @computed get offerName() {
    return getIn(this._content, ['Name']);
  }

  @computed get price() {
    return getIn(this._content, ['TotalPrice']);
  }

  @computed get typeId() {
    return getIn(this._content, ['refRentalServiceTypeId']);
  }
}


class ServiceUnconditioned {
  constructor(content) {
    this._content = content;
  }

  @computed get id() {
    return getIn(this._content, ['Id']);
  }

  @computed get name() {
    return getIn(this._content, ['Name']);
  }

  @computed get description() {
    return getIn(this._content, ['Description']);
  }

  @computed get price() {
    return getIn(this._content, ['ResultPrice'])
  }

  @computed get fixedPrice() {
    return getIn(this._content, ['FixedPrice'])
  }

  @computed get typeId() {
    return getIn(this._content, ['refRentalServiceTypeId']);
  }
}

class ServiceConditioned {
  constructor(content) {
    this._content = content;
  }

  @computed get id() {
    return getIn(this._content, ['Id']);
  }

  @computed get name() {
    return getIn(this._content, ['Name']);
  }

  @computed get description() {
    return getIn(this._content, ['Description']);
  }

  @computed get price() {
    return getIn(this._content, ['ResultPrice'])
  }

  @computed get fixedPrice() {
    return getIn(this._content, ['FixedPrice'])
  }
}

class Consumable {
  @observable _content;

  constructor(content) {
    this._content = content;
  }

  @computed get name() {
    return getIn(this._content, ['Name']);
  }

  @computed get unit() {
    return getIn(this._content, ['Unit']);
  }

  @computed get minQuantity() {
    return getIn(this._content, ['MinQuantity']);
  }

  @computed get freeUnitQuantitySum() {
    return getIn(this._content, ['FreeUnitQuantitySum']);
  }

  @computed get startWord() {
    return "-"
  }
  /// !?!?!?!?!? isRange???

  @computed get endWord() {
    return "-"
  }

  @computed get pricePerUnit() {
    return getIn(this._content, ['pricePerUnit']);
  }

  @computed get price() {
    return getIn(this._content, ['Price']);
  }
}

class CancellationFee {
  constructor(content) {
    this._content = content;
  }

  @computed get minHoursPP() {
    let value = getIn(this._content, ['MinHoursPriorToPickup'])
    return parseInt(value, 10);
  }

  @computed get rate() {
    return getIn(this._content, ['Rate']);
  }

  @computed get fix() {
    return getIn(this._content, ['Fix']);
  }
}

class Payment {
  @observable _content;

  constructor(content) {
    this._content = content;
  }

  @computed get date() {
    return getIn(this._content, ['Date']);
  }

  @computed get description() {
    return getIn(this._content, ['Description']);
  }


  @computed get amount() {
    return getIn(this._content, ['PaymentAmount']);
  }
}

class ExtraItem {
  @observable _content;

  constructor(content) {
    this._content = content;
  }

  @computed get name() {
    return getIn(this._content, ['DescriptionNote']);
  }

  @computed get price() {
    return getIn(this._content, ['Amount'], 0);
  }
}

class RecentBookingDetail {
  @observable _content;

  constructor(content) {
    this._content = content;
  }

  @computed get name() {
    return getIn(this._content, ['Name']);
  }

  @computed get bookingStartDate() {
    return getIn(this._content, ['RentingStartDate']);
  }

  @computed get bookingEndDate() {
    return getIn(this._content, ['RentingEndDate']);
  }

  @computed get bookingNumber() {
    return getIn(this._content, ['Number']);
  }

  @computed get transactionStatus() {
    return getIn(this._content, ['RentalTransactionStatus_Name']);
  }

  @computed get transactionStatusId() {
    return getIn(this._content, ['refRentalTransactionStatusId']);
  }

  @computed get totalPrice() {
    return getIn(this._content, ['TotalDiscountedPrice'])
  }

  @computed get totalDiscount() {
    return getIn(this._content, ['TotalDiscountPrice'])
  }

  @computed get paymentBalance() {
    return getIn(this._content, ['PaymentBalance']);
  }

  @computed get deposit() {
    return getIn(this._content, ['Deposit']);
  }

  @computed get currency() {
    return getIn(this._content, ['Currency_Name']);
  }

  @computed get mainObjectOffers() {
    return getIn(this._content, ['MainObjectOffers', 'RentalTransactionOffer'], [])
      .map(o => new MainObjectOffer(o));
  }

  @computed get accessoryOffers() {
    return getIn(this._content, ['AccessoryObjectOffers', 'RentalTransactionOffer'], [])
      .map(o => new AccessoryOffer(o));
  }

  @computed get mainObjectOffersSubtotalAmount() {
    return getIn(this._content, ['MainObjectOffers', 'SubtotalAmount'], [])
  }

  @computed get accessoryOffersSubtotalAmount() {
    return getIn(this._content, ['AccessoryObjectOffers', 'SubtotalAmount']);
  }

  @computed get servicesUnconditioned() {
    return getIn(this._content, ['ServicesWithoutConditional', 'RentalTransactionService'], [])
      .map(o => new ServiceUnconditioned(o));
  }

  @computed get subtotalServicesUnconditioned() {
    return getIn(this._content, ['ServicesWithoutConditional', 'SubtotalAmount'])
  }

  @computed get servicesConditioned() {
    return getIn(this._content, ['ConditionalServices', 'RentalTransactionService'], [])
      .map(o => new ServiceConditioned(o));
  }

  @computed get subtotalServicesConditioned() {
    return getIn(this._content, ['ConditionalServices', 'SubtotalAmount'])
  }

  @computed get consumables() {
    return getIn(this._content, ['Consumables', 'RentalTransactionConsumable'], [])
      .map(o => new Consumable(o));
  }

  @computed get subtotalConsumables() {
    return getIn(this._content, ['Consumables', 'SubtotalAmount'], []);
  }

  @computed get cancellationFees() {
    return getIn(this._content, ['RentalTransactionCancellationFee'], [])
      .map(o => new CancellationFee(o))
  }

  @computed get payments() {
    return getIn(this._content, ['Payments', 'RentalTransactionPayment'], [])
      .map(o => new Payment(o));
  }

  @computed get bookingDetailSubtotalAmount() {
    return this.mainObjectOffersSubtotalAmount && this.servicesUnconditionedSubtotalAmount &&
      parseFloat(this.mainObjectOffersSubtotalAmount) + parseFloat(this.servicesUnconditionedSubtotalAmount);
  }

  @computed get subtotalMainObjectAndAccessories() {
    return this.mainObjectOffersSubtotalAmount && this.accessoryOffersSubtotalAmount &&
      (parseFloat(this.mainObjectOffersSubtotalAmount) + parseFloat(this.accessoryOffersSubtotalAmount));
  }

  @computed get bookingDetailAccessorySubtotalAmount() {
    return getIn(this._content, ['AccessoryObjectOffers', 'SubtotalAmount']);
  }

  @computed get organizationId() {
    return getIn(this._content, ['refOrganizationId']);
  }

  @computed get objectId() {
    return getIn(this._content, ['refRentalObjectId']);
  }

  @computed get fullpaymentDueDate() {
    return getIn(this._content, ['FullpaymentDueDate']);
  }

  @computed get downpaymentDueDate() {
    return getIn(this._content, ['DownpaymentDueDate']);
  }

  @computed get downpaymentAmount() {
    return getIn(this._content, ['DownpaymentAmount']);
  }

  @computed get extras() {
    return getIn(this._content, ['RentalTransactionAdHoc'], [])
      .map(o => new ExtraItem(o));
  }

  @computed get subtotalExtras() {
    return this.extras.reduce((a, b) => a + parseFloat(b.price), 0);
  }

  @computed get vatRate() {
    return getIn(this._content, ['Vat', 'VatRate'], 0)
  }

  @computed get vatAmount() {
    return getIn(this._content, ['Vat', 'sumChargeVatAmount'], 0)
  }

  @computed get fulfillmentStatuses() {
    let ffStatus = this._content.RentalObjectFulfillmentTypeStatus;
    if (ffStatus && ffStatus.length > 0 && ffStatus[0].RentalObjectFulfillmentTypeStatusTransition) {
      return ffStatus[0].RentalObjectFulfillmentTypeStatusTransition;
    }
    return null;
  }
}

export class VRecentBookingDetail {
  constructor(flasher, api, navigator, rentalObject, organization) {
    this.flasher = flasher;
    this.api = api;
    this.navigator = navigator;
    this.rentalObject = rentalObject;
    this.organization = organization;
  }

  @observable trxId;
  @observable recentBookingDetailContent = {};

  async fetchRecentBookingDetail({ transactionId }) {
    this.recentBookingDetailContent = {};
    this.recentBookingDetailContent = await this.api.getRecentBookingDetail({ transactionId });
    const organizationId = this.detail.organizationId;
    const objectId = this.detail.objectId;
    await Promise.all([
      this.rentalObject.cFetch({ orgId: organizationId, objId: objectId }),
      this.organization.cFetch({ orgId: organizationId }),
    ]);
  }

  async cancelBooking() {
    let cancellationFeeInfo = await this.api.getCancellationFee({ trxId: this.trxId })
    if (await confirmationDialog.confirm(
      <p>
        {translate("cancelBookingMessage", "You are going to cancel this booking. Are you sure?")}<br />
        {cancellationFeeInfo.MessageWarn && <span>{translate("cancelBookingNoteLabel", "NOTE:")} {cancellationFeeInfo.MessageWarn}</span>}
      </p>
    )) {
      let ffStatusCancelId = '';
      if (this.detail.fulfillmentStatuses && this.detail.fulfillmentStatuses.length > 0) {
        let cancelStatus = this.detail.fulfillmentStatuses.find(item => item.refRentalTransactionStatusId === constants.BOOKING_STATUS_TYPE.CANCELLED);
        if (cancelStatus) {
          ffStatusCancelId = cancelStatus.refRentalTransactionFulfillmentStatusId;
        }
      }
      this.recentBookingDetailContent = await this.api.cancelBooking({ trxId: this.trxId, ffStatusCancelId });
    }
  }

  @computed get detail() {
    return new RecentBookingDetail(this.recentBookingDetailContent);
  }

  @computed get recentBookingDetail() {
    return this.recentBookingDetailContent;
  }

  async startOrUpdate({ trxId }) {
    this.trxId = trxId;
    try {
      this.flasher.setOther('Loading.')
      await this.fetchRecentBookingDetail({ transactionId: trxId });
    }
    catch (e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther()
    }

  }

  stop() {

  }
} 


// WEBPACK FOOTER //
// ./src/view/VRecentBookingDetail.js